var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14V16",
    stroke: "#FAFBFC",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C11.675 15 11 14.325 11 13.5C11 12.675 11.675 12 12.5 12C13.325 12 14 12.675 14 13.5C14 14.325 13.325 15 12.5 15Z",
    fill: "#FAFBFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63877 19.22H17.3612C17.9432 19.22 18.4944 19.0417 18.9141 18.7222C19.3345 18.4022 19.65 17.9134 19.65 17.3227V10.6773C19.65 10.0866 19.3345 9.59779 18.9141 9.27779C18.4944 8.95834 17.9432 8.77999 17.3612 8.77999H7.63877C7.05675 8.77999 6.50562 8.95834 6.08591 9.27779C5.66549 9.59779 5.35 10.0866 5.35 10.6773V17.3227C5.35 17.9134 5.66549 18.4022 6.08591 18.7222C6.50562 19.0417 7.05675 19.22 7.63877 19.22Z",
    stroke: "#FAFBFC",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2851 8.12309C16.2851 8.48207 16.5761 8.77309 16.9351 8.77309C17.294 8.77309 17.5851 8.48207 17.5851 8.12309H16.2851ZM7.41506 8.12309C7.41506 8.48207 7.70608 8.77309 8.06506 8.77309C8.42405 8.77309 8.71506 8.48207 8.71506 8.12309H7.41506ZM12.1881 4.65H12.812V3.35H12.1881V4.65ZM12.812 4.65C14.7301 4.65 16.2851 6.20496 16.2851 8.12309H17.5851C17.5851 5.48699 15.4481 3.35 12.812 3.35V4.65ZM8.71506 8.12309C8.71506 6.20496 10.27 4.65 12.1881 4.65V3.35C9.55205 3.35 7.41506 5.48699 7.41506 8.12309H8.71506Z",
    fill: "#FAFBFC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.72d71b6d.svg";
export { ForwardRef as ReactComponent };